<template>
    <div class="new-item" @click="handleClick(item)">
        
        <div class="new-item__cover">
            <img v-if="item.cover_image_url" :src="item.cover_image_url" />
            <img v-else-if="item.image_url" :src="item.image_url" />
            <img v-else src="https://edu-img.therol.cn/autohk/11.png" />
        </div>

        <div class="new-item__title">
            <div class="title">{{ item.title }}</div>
            <!-- <div class="time" v-if="item.publish_time">{{ dayjs(item.publish_time ).format('YYYY/MM/DD') }}</div> -->
        </div>
        <div class="new-item__summary">{{ item.summary }}</div>
    </div>
</template>

<script setup>
    import { useRouter } from 'vue-router'
    const router = useRouter()

    defineProps({
        item: { type: Object }
    })
    
    const handleClick = (item) => {
        const path =  item.link_url ? item.link_url : `/article/${item.id}`
        router.push(path)
    }
    
</script>

<style lang="scss" scoped>
    .new-item {
        width: 387px; 
        border-radius: 30px; 
        overflow: hidden;
        background-color: #FFFFFF;
        cursor: pointer;

        &__cover {
            width: 100%;
            height: 200px;
            overflow: hidden;

            img {
                width: 100%;
                height: 200px;
                object-fit: cover;
                transition: all 0.3s ease-in-out;  
            }

            img:hover {
                transform: scale(1.2);
            }
        }

        
        &__title {
            font-weight: 500;
            font-size: 18px;
            line-height: 25px;
            padding: 24px 22px 0 22px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title {
                font-family: PingFangSC-medium;
                max-width: 100%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .time{  
                color: #999999;
                font-weight: 400;
                font-size: 14px;
                letter-spacing: 2px;
            }
        }
        
        &__summary {
            color: #666666;
            font-weight: 400;
            font-size: 16px;
            letter-spacing: 2px;
            margin: 8px 22px 24px 22px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
/* 响应式设计 */
@media (max-width: 768px) {
    .new-item {
        width: 100%; 
        border-radius: 8px; 
        margin-top: 18px;
        
        &__title {
            font-size: 16px;
            letter-spacing: 1px;
            line-height: 22px;
            padding: 14px 12px 0 12px;

            .time{  
                font-size: 10px;
                letter-spacing: 1px;
            }
        }
        
        &__summary {
            font-size: 14px;
            letter-spacing: 1px;
            margin: 8px 12px 14px 12px;
        }
    }
}
</style>